// extracted by mini-css-extract-plugin
export default {"productGallery":"jK-z","inQuickShop":"kK-z"};